import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/Login";
import ReportPreview from "../components/ReportPreview";
Vue.use(VueRouter);
const routes = [
  {
    path: "/test",
    name: "Test",
    component: () => import("../components/Test"),
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/report/preview/:company_id/:unique_id",
    name: "Report Preview",
    component: ReportPreview,
  },
  {
    path: "/",
    name: "Dashboards",
    redirect: "/dashboard",
  },
  {
    path: "/transaction",
    name: "Transaction",
    meta: {
      title: "Bank Transactions",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/List"),
  },
  {
    path: "/report/:type",
    name: "Report",
    meta: {
      title: "Report",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/Summary"),
  },
  {
    path: "/report/project/:project_id/vendor",
    name: "Project's Vendor",
    meta: {
      title: "Project's Vendor",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/ProjectVendor"),
  },
  {
    path: "/report/project/:project_id/transactiontype",
    name: "Project's Transaction Type",
    meta: {
      title: "Project's Transaction Type",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/ProjectTransactionType"),
  },
  {
    path: "/report/project/:project_id/vendor/:vendor_id/:is_expence",
    name: "Vendor's Transaction",
    meta: {
      title: "Vendor's Transaction",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/ReportTransaction"),
  },
  {
    path:
      "/report/project/:project_id/transactiontype/:trans_type_id/vendor/:vendor_id/:is_expence",
    name: "Transaction Type's Transaction",
    meta: {
      title: "Transaction Type's Transaction",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () =>
      import("../components/Transaction/TransactionTypeTransaction"),
  },
  {
    path: "/report/project/:project_id/transactiontype/:trans_type_id/vendor",
    name: "Transaction Type's Vendor",
    meta: {
      title: "Transaction Type's Vendor",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/TransactionTypeVendor"),
  },
  {
    path: "/report/bank/:bank_id",
    name: "Bank's Transaction",
    meta: {
      title: "Bank's Transaction",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/BankTransaction"),
  },
  {
    path: "/report/vendor/:vendor_id/:is_expence",
    name: "Vendor's Transactions",
    meta: {
      title: "Vendor's Transactions",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/VendorTransaction"),
  },
  {
    path: "/report_income/:bank_id",
    name: "Income Customers",
    meta: {
      title: "Income Customers",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/IncomeCustomer"),
  },
  {
    path: "/report_income/:bank_id/:customer_id",
    name: "Income Project",
    meta: {
      title: "Income Project",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/IncomeProject"),
  },
  {
    path: "/report_income/:bank_id/:customer_id/:project_id",
    name: "Income Transaction",
    meta: {
      title: "Income Transaction",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/IncomeTransaction"),
  },
  // {
  //   path: '/report_expense',
  //   name: "Expense Customer",
  //   meta : {
  //     title : "Expense Customer",
  //     body_class: 'two-bottom-bar',
  //     side_bar_class: 'two-bottom-bar-side-bar'
  //   },
  //   component: () => import('../components/Transaction/ExpenceCustomer')
  // },
  // {
  //   path: '/report_expense/:customer_id',
  //   name: "Expense Project",
  //   meta : {
  //     title : "Expense Project",
  //     body_class: 'two-bottom-bar',
  //     side_bar_class: 'two-bottom-bar-side-bar'
  //   },
  //   component: () => import('../components/Transaction/ExpenceProject')
  // },
  // {
  //   path: '/report_expense/:customer_id/:project_id',
  //   name: "Expense Chart Of Account",
  //   meta : {
  //     title : "Expense Chart Of Account",
  //     body_class: 'two-bottom-bar',
  //     side_bar_class: 'two-bottom-bar-side-bar'
  //   },
  //   component: () => import('../components/Transaction/ExpenceChartOfAccount')
  // },
  {
    path: "/report_expense/:bank_id",
    name: "Expense Vendor",
    meta: {
      title: "Expense Vendor",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/ExpenceVendor"),
  },
  {
    path: "/report_expense/:bank_id/:vendor_id/:is_expence",
    name: "Expense Transaction",
    meta: {
      title: "Expense Transaction",
      body_class: "two-bottom-bar",
      side_bar_class: "two-bottom-bar-side-bar",
    },
    component: () => import("../components/Transaction/ExpenceTransaction"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    meta: {
      title: "Home",
    },
    component: () => import("../components/Dashboard/Data"),
  },
  {
    path: "/customers",
    name: "customers",
    meta: {
      title: "Customers",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/customers/List"),
  },
  {
    path: "/customers/add",
    name: "customers_add",
    meta: {
      title: "",
    },
    component: () => import("../components/customers/Add"),
  },
  {
    path: "/customer/edit/:id",
    name: "customers_edit",
    meta: {
      title: "",
    },
    component: () => import("../components/customers/Edit"),
  },
  {
    path: "/projects",
    name: "projects",
    meta: {
      title: "Projects",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/projects/List"),
  },
  {
    path: "/projects/document",
    name: "projects_document",
    meta: {
      title: "Projects",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/document/DocList"),
  },
  {
    path: "/projects/:project_type",
    name: "projects_type",
    meta: {
      title: "Projects",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/projects/List"),
  },
  {
    path: "/projects/add",
    name: "project_add",
    meta: {
      title: "",
    },
    component: () => import("../components/projects/Add"),
  },
  {
    path: "/projects/edit/:id",
    name: "project_edit",
    meta: {
      title: "Edit Project",
    },
    component: () => import("../components/projects/Edit"),
  },
  {
    path: "/jobs",
    name: "jobs",
    meta: {
      title: "Jobs",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/jobs/List"),
  },
  {
    path: "/cabinets",
    name: "cabinets",
    meta: {
      title: "Cabinets",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/cabinets/List"),
  },
  {
    path: "/items",
    name: "items",
    meta: {
      title: "Items",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/items/List"),
  },
  {
    path: "/items/add",
    name: "item_add",
    meta: {
      title: "",
      module_icon: "",
      action_icon: "",
    },
    component: () => import("../components/items/Add"),
  },
  {
    path: "/items/edit/:id",
    name: "item_edit",
    meta: {
      title: "",
      //module_icon: 'mdi-alpha-i-circle-outline',
      //action_icon: 'mdi-account-edit-outline mdi-dark'
    },
    component: () => import("../components/items/Edit"),
  },
  {
    path: "/users",
    name: "users",
    meta: {
      title: "Users",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/users/List"),
  },
  {
    path: "/users/add",
    name: "users_add",
    meta: {
      title: "",
    },
    component: () => import("../components/users/Add"),
  },
  {
    path: "/users/edit/:id",
    name: "user_edit",
    meta: {
      title: "Edit User",
    },
    component: () => import("../components/users/Edit"),
  },
  {
    path: "/vendors",
    name: "vendors",
    meta: {
      title: "Vendors",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/vendors/List"),
  },
  {
    path: "/vendors/add",
    name: "vendor_add",
    meta: {
      title: "",
    },
    component: () => import("../components/vendors/Add"),
  },
  {
    path: "/vendors/edit/:id",
    name: "vendor_edit",
    meta: {
      title: "Edit Vendor",
    },
    component: () => import("../components/vendors/Edit"),
  },
  {
    path: "/accounts",
    name: "accounts",
    meta: {
      title: "Chart of Accounts",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/accounts/List"),
  },
  {
    path: "/accounts/add",
    name: "account_add",
    meta: {
      title: "Add Account",
    },
    component: () => import("../components/accounts/Add"),
  },
  {
    path: "/accounts/edit/:id",
    name: "account_edit",
    meta: {
      title: "Edit Account",
    },
    component: () => import("../components/accounts/Edit"),
  },
  {
    path: "/jobtype",
    name: "JobType",
    meta: {
      title: "Job Type",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/jobtype/List"),
  },
  {
    path: "/cabinetcolor",
    name: "CabinetColor",
    meta: {
      title: "Cabinet Color",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/cabinetcolor/List"),
  },
  {
    path: "/cabinetline",
    name: "CabinetLine",
    meta: {
      title: "Cabinet Line",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/cabinetline/List"),
  },
  {
    path: "/cabinetstyle",
    name: "CabinetStyle",
    meta: {
      title: "Cabinet Style",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/cabinetstyle/List"),
  },
  {
    path: "/cabinetdoorstyle",
    name: "CabinetDoorStyle",
    meta: {
      title: "Cabinet Door Style",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/cabinetdoorstyle/List"),
  },
  {
    path: "/cabinetwood",
    name: "CabinetWood",
    meta: {
      title: "Cabinet Wood",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/cabinetwood/List"),
  },
  {
    path: "/cabinettype",
    name: "CabinetType",
    meta: {
      title: "Cabinet Type",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/cabinettype/List"),
  },
  {
    path: "/accounttype",
    name: "AccountType",
    meta: {
      title: "Account Type",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/accounttype/List"),
  },
  {
    path: "/invoicegroup",
    name: "InvoiceGroup",
    meta: {
      title: "Invoice Group",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/invoicegroup/List"),
  },
  {
    path: "/color",
    name: "Color",
    meta: {
      title: "Color",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/color/List"),
  },
  {
    path: "/uom",
    name: "Uom",
    meta: {
      title: "UOM",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/uom/List"),
  },
  {
    path: "/group",
    name: "Group",
    meta: {
      title: "Group",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/group/List"),
  },
  {
    path: "/area",
    name: "Area",
    meta: {
      title: "Area",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/area/List"),
  },
  {
    path: "/documenttype",
    name: "Document Type",
    meta: {
      title: "Document Type",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/documenttype/List"),
  },
  {
    path: "/document/view/:type/:o_id/:doc_id/:doc_type/:doc_folder",
    name: "document_view",
    meta: {
      title: "Document View",
      body_class: "",
      side_bar_class: "",
    },
    component: () => import("../components/document/View"),
  },
  {
    path: "/loginlogs",
    name: "LoginLog",
    meta: {
      title: "Login Logs",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/loginlog/List"),
  },
  {
    path: "/role-permission",
    name: "RolePermission",
    meta: {
      title: "Role & Permission",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/rolepermission/List"),
  },
  {
    path: "/zip",
    name: "Zip",
    meta: {
      title: "Zip",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/zip/List"),
  },
  {
    path: "/state",
    name: "State",
    meta: {
      title: "State",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/state/List"),
  },
  {
    path: "/city",
    name: "City",
    meta: {
      title: "City",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/city/List"),
  },
  {
    path: "/transactiontype",
    name: "TransactionType",
    meta: {
      title: "Transaction Type",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/transactiontype/List"),
  },
  {
    path: "/domains",
    name: "EmailDomains",
    meta: {
      title: "Email Domains",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/domain/List"),
  },
  {
    path: "/vendortype",
    name: "VendorType",
    meta: {
      title: "Vendor Type",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/vendortype/List"),
  },
  {
    path: "/profile",
    name: "Profile",
    meta: {
      title: "Profile",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/profile/View"),
  },
  {
    path: "/company_info",
    name: "Company info",
    meta: {
      title: "Company Info",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/companyinfo/View"),
  },
  {
    path: "/company_setup",
    name: "Company Setup",
    meta: {
      title: "Company Setup",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/companysetup/View"),
  },
  {
    path: "/calendar",
    name: "Calendar",
    meta: {
      title: "Calendar",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/calendar/View"),
  },
  {
    path: "/task",
    name: "Task",
    meta: {
      title: "Task",
      body_class: "one-bottom-bar",
      side_bar_class: "one-bottom-bar-side-bar",
    },
    component: () => import("../components/task/List"),
  },
];

const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {
  const publicPages = [
    "/login",
    "/report/preview/" + to.params.company_id + "/" + to.params.unique_id,
  ];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("token");
  if (authRequired && !loggedIn) {
    next("/login");
  } else if (!authRequired && loggedIn) {
    next("/");
  } else {
    next();
  }
});
export default router;
